import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import { useTheme } from '@mui/material/styles';
import Avatar from '@mui/material/Avatar';
import LogoutIcon from '@mui/icons-material/Logout';
import { disconnectWallet } from '@brickken/web3';
import { useWallet } from '../../hooks/useWallet';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { generateAvatarURL } from '@cfx-kit/wallet-avatar';
import { ShortWalletAddressDisplay } from '../ShortWalletAddressDisplay/ShortWalletAddressDisplay';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import { profileMenuStyles } from './profileMenuStyles';

export const ProfileMenu = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const isDark = theme.palette.mode === 'dark';
  const classes = profileMenuStyles(theme, isDark);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const { userAddress } = useWallet();
  const open = Boolean(anchorEl);
  const handleDisconnectWallet = async () => {
    await disconnectWallet();
  };

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Grid item xs='auto'>
        <Box
          sx={classes.menuBox}
          onClick={handleClick}
          onMouseOver={handleClick}
        >
          <IconButton
            onClick={handleClick}
            size='small'
            aria-controls={open ? 'account-menu' : undefined}
            aria-haspopup='true'
            aria-expanded={open ? 'true' : undefined}
          >
            <Avatar
              sx={classes.avatar}
              src={userAddress && generateAvatarURL(userAddress)}
            />
          </IconButton>
          <ShortWalletAddressDisplay userWalletAddress={userAddress} />
        </Box>
      </Grid>
      <Menu
        sx={classes.menu}
        anchorEl={anchorEl}
        id='account-menu'
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        onMouseLeave={handleClose}
        hideBackdrop
        PaperProps={{
          elevation: 0,
          sx: classes.paperProps
        }}
      >
        <MenuItem
          sx={classes.menuItem}
          onClick={handleDisconnectWallet}
          disableGutters={true}
        >
          <Typography sx={classes.menuText} variant='body1'>
            {t('vesting.disconnect_wallet.button')}
          </Typography>
          <ListItemIcon aria-label='wallet' sx={classes.listItemIcon}>
            <LogoutIcon color='info' />
          </ListItemIcon>
        </MenuItem>
      </Menu>
    </>
  );
};
